import React from 'react';

import {  
  Card,  
  Row,
  Col  
} from 'react-bootstrap';

import Utils from '../../Utils';

import CustomTemplateList from './CustomTemplateList';

const StepCustomTemplate = (props) => {

  const renderInfo = () => {
    return <Card className="card-box w-100 custempage">
      <Card.Body className="p-5">        
        <h3 className="mt-0 mb-3">Choose Your Template <span className="fa fa-hand-pointer-0"></span></h3>

        <ol className="insList">
          <li>Select any of the templates <span>to create your own custom slides.</span></li>
          <li>By clicking <span>on the template you can revise the text.</span></li>
          <li>By selecting <span>any of the below # keywords it will show you the matching templates.</span></li>
        </ol>

        <CustomTemplateList onSlideSave={props.onSlideSave} />
      </Card.Body>  
    </Card>
  }  
  
  return <Row>
    <Col className="mt-3 mb-5">{renderInfo()}</Col>    
  </Row>;
}

export default StepCustomTemplate;